/**
 * Removes a leading "https://" from a URL, if present.
 *
 * @param {string} url - The URL string to process
 * @returns {string} The URL with "https://" removed if it was present, otherwise the original URL
 */
export function stripHttps(url: string): string {
  return url.replace(/^https:\/\//i, '');
}

/**
 * Truncates a URL to a maximum displayed length by keeping the start and end sections.
 *
 * @param {string} url - The URL string to truncate
 * @param {number} [maxLength=80] - The maximum length of the truncated URL
 * @param {number} [startChars=30] - Number of characters to keep from the start
 * @param {number} [endChars=30] - Number of characters to keep from the end
 * @returns {string} The truncated URL with "[...]" in the middle, or the original URL if no truncation is needed
 */
export function truncateUrl(url: string, maxLength = 80, startChars = 30, endChars = 30): string {
  // Return original URL if it's shorter than maxLength
  if (url.length <= maxLength) {
    return url;
  }

  // Extract the start and end parts
  const start = url.substring(0, startChars);
  const end = url.substring(url.length - endChars);

  // Return truncated URL with [...]
  return `${start}[...]${end}`;
}
